import type { PaymentHistoryCommon } from '@zg-rentals/applications-utils';
import { PaymentHistoryGridLegacy } from './PaymentHistoryGridLegacy';
import { PaymentHistoryGridJ9 } from './PaymentHistoryGridJ9';

export function PaymentHistoryGrid({ paymentHistory }: { paymentHistory: PaymentHistoryCommon }) {
  const Component = paymentHistory.type === 'j9' ? PaymentHistoryGridJ9 : PaymentHistoryGridLegacy;
  return <Component items={paymentHistory.items} />;
}
